/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import {
  ButtonGroup,
  IconButton,
  Paper,
  TableContainer,
  Tooltip,
} from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { handleEditOpen, rowValue } from "../../../redux/Reducer/ModalSlice";
import {
  ActiveStatus,
  InactiveStatus,
  StatusContainer,
} from "../../Dashboard/Dashboard.style";
import EditIcon from "@mui/icons-material/Edit";
import TableFilter from "../../table-components/filter/TableFilter";
import TableComp from "../../table-components/table/TableComp";
import Pagination from "../../table-components/pagination/Pagination";
import AddModal from "../../modal/AddModal";
import AddSubmenu from "./AddSubmenu";
import EditModal from "../../modal/EditModal";
import EditSubmenu from "./EditSubmenu";
import { useQuery } from "@tanstack/react-query";

const data1 = [
  // { sl: 201, Menu_name: "Dashboard", active_status: true },
  {
    sl: 201,
    menu_id: 102,
    Menu_name: "Security",
    submenu_name: "User Level",
    route_name: "security/user-level",
    active_status: true,
  },
  {
    sl: 222,
    menu_id: 102,
    Menu_name: "Security",
    submenu_name: "Security Level",
    route_name: "security/security-level",
    active_status: true,
  },
  {
    sl: 223,
    menu_id: 102,
    Menu_name: "Security",
    submenu_name: "Menu Setup",
    route_name: "security/menu-setup",
    active_status: true,
  },
  {
    sl: 224,
    menu_id: 102,
    Menu_name: "Security",
    submenu_name: "Submenu Setup",
    route_name: "security/submenu-setup",
    active_status: true,
  },

  {
    sl: 231,
    menu_id: 103,
    Menu_name: "Setup",
    submenu_name: "User Setup",
    route_name: "setup/user-setup",
    active_status: true,
  },
  {
    sl: 232,
    menu_id: 103,
    Menu_name: "Setup",
    submenu_name: "Occupation Setup",
    route_name: "setup/occupation-setup",
    active_status: true,
  },
  {
    sl: 233,
    menu_id: 103,
    Menu_name: "Setup",
    submenu_name: "Sponsor Setup",
    route_name: "setup/sponsor-setup",
    active_status: true,
  },
  {
    sl: 234,
    menu_id: 103,
    Menu_name: "Setup",
    submenu_name: "Study Setup",
    route_name: "setup/study-setup",
    active_status: true,
  },
  {
    sl: 241,
    menu_id: 104,
    Menu_name: "Volunteer Bank",
    submenu_name: "New Registration",
    route_name: "/volunteer/volunteerRegister",
    active_status: true,
  },
  {
    sl: 242,
    menu_id: 104,
    Menu_name: "Volunteer Bank",
    submenu_name: "Registration From PRO",
    route_name: "/volunteer/VolunteerPro",
    active_status: true,
  },
  {
    sl: 243,
    menu_id: 104,
    Menu_name: "Volunteer Bank",
    submenu_name: "Volunteer Bank",
    route_name: "/volunteer/volunteerBank",
    active_status: true,
  },
];

const SubmenuTable = ({ data, subRefetch }) => {
  const dispatch = useDispatch();

  function handleEdit(rowData) {
    dispatch(handleEditOpen());
    dispatch(rowValue(rowData));
  }

  const {
    refetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: moduleInfo = [],
  } = useQuery({
    queryKey: ["moduleInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/moduleSetup`
      );
      const data = await res.json();
      return data;
    },
  });

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "sa_mlinks_id",
        // Cell: (row) => {
        //   return <div>{Number(row.row.id) + 1}</div>;
        // },
        Filter: false,
      },
      {
        Header: "Menu name",
        accessor: "moduleName",
        Filter: false,
      },
      {
        Header: "Submenu Name",
        accessor: "sa_mlink_name",
        Filter: false,
      },
      {
        Header: "Submenu Route",
        accessor: "url_uri",
        Filter: false,
      },
      {
        Header: "Active Status",
        accessor: "active_fg",
        Filter: false,
        Cell: (e) => (
          <div
            style={{
              marginLeft: "10Px",
            }}
          >
            {e.value === "Y" ? (
              <StatusContainer>
                <ActiveStatus>Active</ActiveStatus>
              </StatusContainer>
            ) : (
              <StatusContainer>
                <InactiveStatus>Inactive</InactiveStatus>
              </StatusContainer>
            )}
          </div>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            Action
          </div>
        ),
        accessor: "col3",
        Cell: (row) => (
          <ButtonGroup
          // style={{
          //   display: "flex",
          //   justifyContent: "center",
          // }}
          >
            <IconButton
              size="small"
              sx={{ "&:hover": { color: "#2e68e8" } }}
              style={{ color: "#2196F3" }}
              // style={{}}
              variant="none"
              onClick={() => handleEdit(row.row.original)}
            >
              <Tooltip title="Update">
                <EditIcon sx={{ fontSize: 18 }} />
              </Tooltip>
            </IconButton>
          </ButtonGroup>
        ),
        Filter: false,
        disableSortBy: true,
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    setGlobalFilter,
  } = useTable(
    { columns, data },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );
  const { globalFilter } = state;
  const { pageIndex, pageSize } = state;
  return (
    <>
      <div>
        <TableFilter
          filter={globalFilter}
          setFilter={setGlobalFilter}
          ButtonName="Add Submenu"
        />
      </div>
      <TableContainer component={Paper}>
        <TableComp
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          prepareRow={prepareRow}
          pageIndex={pageIndex}
        />

        {/* {isLoading && (
        <div
          style={
            {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "280px",
            }
            // display:"flex",
          }
        >
          <CircularProgress />
        </div>
      )} */}

        <Pagination
          page={page}
          pageIndex={pageIndex}
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageCount={pageCount}
        />
      </TableContainer>

      <AddModal ModalWidth="sm" ModalTitle="Add Submenu Name">
        <AddSubmenu moduleInfo={moduleInfo} refetch={refetch} />
      </AddModal>

      <EditModal ModalWidth="sm" ModalTitle="Edit Submenu Information">
        <EditSubmenu moduleInfo={moduleInfo} subRefetch={subRefetch} />
      </EditModal>
    </>
  );
};

export default SubmenuTable;
